import { FC } from 'react'
import { Calendar as MantineCalendar } from '@mantine/dates'
import dayjs from 'dayjs'
import useCalendar from '../../../hooks/useCalendar'
import styles from './styles'
import { isDisabledDate } from '../../../utilities/utils'
import { SeatBooking } from '../../../types/andTypes'
import useBankHolidays from '../../../hooks/useBankHolidays'

type Bookings = {
  selectedDay: Date
  setSelectedDay: (value: Date) => void
  seatsBookings: SeatBooking[]
  seatCap: number
  region: string
}

const Calendar: FC<Bookings> = ({
  selectedDay,
  setSelectedDay,
  seatCap,
  seatsBookings,
  region
}) => {
  const { renderDay, renderStyle } = useCalendar(seatCap)
  const bankHolidays = useBankHolidays(region)

  return (
    <MantineCalendar
      data-testid="styled-calendar"
      fullWidth
      allowLevelChange={false}
      size="lg"
      focusable
      nextYearLabel="next year button"
      previousYearLabel="previous year button"
      aria-labelledby="seat availability calendar"
      nextMonthLabel="next month button"
      previousMonthLabel="previous month button"
      value={selectedDay}
      onChange={setSelectedDay}
      renderDay={date => renderDay(date, seatsBookings)}
      dayStyle={date => renderStyle(date, seatsBookings, bankHolidays)}
      minDate={new Date()}
      maxDate={dayjs(new Date()).add(4, 'weeks').toDate()}
      excludeDate={date => isDisabledDate(date, bankHolidays)}
      styles={styles}
    />
  )
}

export default Calendar
